import { render, staticRenderFns } from "./SpecialistTable.vue?vue&type=template&id=5034dbd2&scoped=true&"
import script from "./SpecialistTable.vue?vue&type=script&lang=js&"
export * from "./SpecialistTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistTable.vue?vue&type=style&index=0&id=5034dbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034dbd2",
  null
  
)

export default component.exports